export const REQUEST_INVENTORY_PENDING = "REQUEST_INVENTORY_PENDING";
export const REQUEST_INVENTORY_SUCCESS = "REQUEST_INVENTORY_SUCCESS";
export const REQUEST_INVENTORY_FAILED = "REQUEST_INVENTORY_FAILED";
export const SEND_INQUIRYFORM_PENDING = "SEND_INQUIRYFORM_PENDING";
export const SEND_INQUIRYFORM_SUCCESS = "SEND_INQUIRYFORM_SUCCESS";
export const SEND_INQUIRYFORM_FAILED = "SEND_INQUIRYFORM_FAILED";
export const DOMAIN_API_URL = "https://api.netherlandbunnies.com";

// export const DOMAIN_API_URL = "http://localhost:31775";
